require( 'owl.carousel' );

import newsletter from './newsletter';

jQuery( document ).ready(function($) {
  newsletter();

  $('#header .hamburger').on('click', function (e) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.nav-container' ).toggleClass( 'active' );
		$( '#header .container' ).toggleClass( 'active' );
		$( '#header .logo' ).toggleClass( 'mobile' );
  });

  if ($('#header nav li.current-menu-item').length > 1) {
		$('#header nav li.current-menu-item').removeClass('current-menu-item');
	}

  $('#header nav a').on('click', function(event) {
		if (this.hash !== "") {
      //event.preventDefault();
      // Store hash
			var hash = this.hash;
			var pos = $(hash).offset().top - 80;
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: pos
      }, 800, function(){
				window.location.hash = hash;
				scrollActiveNav(pos);
				$( '.nav-container' ).removeClass( 'active' );
				$( '#header .logo' ).removeClass( 'mobile' );
				$('#header .hamburger').removeClass( 'is-active' );
      });
    }
	});

	function scrollActiveNav(pos) {
    var header_height = $('#header').height() + 40;

		$('#header nav a').each(function(){
			var currLink = $(this);
			var href = currLink.attr('href');
			
			if (href.indexOf('#') != -1) {
				var hash = href.substring(href.indexOf('#'))
				var refElement = $(hash);

				if (refElement.length > 0) {
					if (refElement.position().top - header_height <= pos && refElement.position().top + refElement.outerHeight() - header_height > pos) {
							currLink.parent().addClass("current-menu-item");
					} else {
							currLink.parent().removeClass("current-menu-item");
					}
				}
			}
		});
  }

  $(window).on('scroll', function() {
    const pos = $(document).scrollTop();
    scrollActiveNav(pos)
  });

  scrollActiveNav($(document).scrollTop());
});